// extracted by mini-css-extract-plugin
export default {"formContainer":"authPages_formContainer__-YXWU","loginCard":"authPages_loginCard__q7PrN"};